export const INSURER = process.env.INSURER;
export const INSURER_CONFIG = process.env.INSURER_CONFIG;
